import React from "react";
import { withStyles } from "@material-ui/styles";

import Box from "@material-ui/core/Box";

import TemperatureDetails from "../SiteEntranceExit/Temperature/TemperatureDetails";

import colors from "../../assets/style/colors";

const styles = (theme) => ({
  card: {
    backgroundColor: colors.white,
    overflow: "auto",
    borderRadius: "2px",
    [theme.breakpoints.up("sm")]: {
      maxHeight: "calc(100vh - 199px)",
      height: "calc(100vh - 198px)",
      margin: "12px",
      boxShadow: "0px 2px 2px 0px " + colors.black23,
    },
    [theme.breakpoints.down("sm")]: {
      margin: "12px 6px",
      padding: "24px 10px",
      maxHeight: "calc(100vh - 160px)",
      height: "calc(100vh - 160px)",
    },
  },
});

const ProfileTemperature = (props) => {
  const { classes, language, profileId } = props;

  return (
    <Box className={classes.card}>
      <TemperatureDetails
        language={language}
        profileId={profileId}
        maxWidth={"calc(100vw - 165px)"}
        disableCurrent={true}
      />
    </Box>
  );
};

export default withStyles(styles)(ProfileTemperature);
